import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';

import { AppointmentCalendarHoliday, AppointmentCalendar } from './../../models/calendar/calendar.model';
import { Dropdown } from './../../models/editors/dropdown.model';
import { DateTimePicker } from './../../models/editors/datetimepicker.model';



@Component({
  selector: 'swb-appointment-holiday-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class AppointmentHolidayDetailComponent extends FormDetailBase<AppointmentCalendarHoliday> implements OnInit, OnDestroy {

  private _calendar_id: number;

  public url = 'appointment-calendar-holidays';

  protected _redirect = './appointments';

  public entity = new AppointmentCalendarHoliday({});
  public calendars: Array<AppointmentCalendar> = [];

  public get fieldsConfig(): Array<any> {
    return [
      new Dropdown({
        key: 'appointment_calendar_id',
        label: 'Kalendář',
        options: this._formService.getDropdownValues('title', this.calendars),
        defaultValue: this._calendar_id ? this._calendar_id : this.calendars[0].id
      }),
      new DateTimePicker({
        key: 'datetime_from',
        label: 'Od'
      }),
      new DateTimePicker({
        key: 'datetime_to',
        label: 'Do'
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {


    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    if (typeof this._route.snapshot.params['calendar_id'] !== 'undefined') {
      this._calendar_id = parseInt(this._route.snapshot.params['calendar_id'], 10);
    }

    this._getCalendarsList();

  }

  protected _setupForm(): void {
    this.form = this._formService.toFormGroup(this.fieldsConfig.slice(), this.entity);
    this.formEditors = this._formService.toTemplateInput(this.fieldsConfig.slice(), this.entity);
    this.isInitialized = true;

  }

  public ngOnDestroy(): void {
    // TODO: do something
  }

  private _getCalendarsList() {
    this._apiService.get('appointment-calendars/list')
      .subscribe(
        (response: any) => {
          this.calendars = { ...response }.data;
          this._getEntity();
        },
        (error) => console.error(error)
      );
  }

}
